export default (attributeName) => (el) => {
  const value = el.getAttribute(attributeName);
  el.removeAttribute(attributeName);
  el.setAttribute(attributeName, value);
};
